module.exports = __webpack_public_path__ + "static/media/us.f114bc8d.jpg";